import { render, staticRenderFns } from "./modified_modal.vue?vue&type=template&id=1fb3e4f9&"
import script from "./modified_modal.vue?vue&type=script&lang=js&"
export * from "./modified_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports